<mat-card *ngIf="!loading" class="mcd-card add-nrbes">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >Add New National Standard</mat-card-title
    >
  </mat-card-header>
  <div class="mat-card-wrapper" style="background-color: #f3f3f3">
    <mat-card-content
      class="mcd-card-content"
      style="background-color: #f3f3f3; margin-bottom: 20px"
    >
      <form [formGroup]="addNrbesForm">
        <div class="mcd-edit-form mcd-grbes-form">
          <div style="margin: auto">
            <div
              style="
                padding: 20px 10px 10px 10px;
                background-color: #ffffff;
                border: 1px solid #a0a0a04d;
                border-radius: 8px;
              "
            >
              <div>
                <div class="eqipmentClass">
                  <app-stepper [steps]="formSteps"></app-stepper>
                </div>
                <div class="col-12" style="margin: auto">
                  <mat-stepper
                    [selectedIndex]="currentStepIndex"
                    linear
                    labelPosition="bottom"
                    #stepper
                    (selectionChange)="onStepChange($event)"
                    style="margin-bottom: 10px"
                  >
                    <form [formGroup]="addNrbesForm">
                      <mat-step [stepControl]="step0Group">
                        <ng-template matStepLabel
                          >Category and Location</ng-template
                        >
                        <div class="col-9" style="margin: auto">
                          <div>
                            <div>
                              <label
                                for="operationsCategory"
                                style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                "
                                >Title*
                                <span
                                  matTooltip="Please provide a clear, concise title for the Market Standard "
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "
                                ></span
                              ></label>
                              <div class="title">
                                <input
                                  [ngStyle]="{
                                    'margin-bottom':
                                      addNrbesForm.get('title')?.touched &&
                                      addNrbesForm
                                        .get('title')
                                        ?.hasError('required')
                                        ? '0px'
                                        : '30px',
                                  }"
                                  name="title"
                                  formControlName="title"
                                  required
                                  placeholder="Enter Title"
                                  (paste)="onPasteCleanup('title')"
                                  class="form-title"
                                />
                                <mat-error
                                  *ngIf="
                                    addNrbesForm.get('title').touched &&
                                    addNrbesForm
                                      .get('title')
                                      .hasError('required')
                                  "
                                >
                                  Title is required
                                </mat-error>
                              </div>
                            </div>
                          </div>

                          <div
                            class="dropDown-bottom-Space"
                            *ngIf="this.userRole == 4"
                          >
                            <label
                              for="operationsCategory"
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Country*
                              <span
                                matTooltip="Info about the action"
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span>
                            </label>
                            <div class="category-dropdown-wrapper">
                              <ng-multiselect-dropdown
                                class="dropdown-list"
                                [placeholder]=""
                                [settings]="countrydropdownSettings"
                                [data]="countryDropdownList"
                                [(ngModel)]="countryselected"
                                (onSelect)="onCountrySelect($event)"
                                [ngModelOptions]="{ standalone: true }"
                              >
                              </ng-multiselect-dropdown>
                              <mat-error
                                *ngIf="
                                  addNrbesForm.get('countryId').touched &&
                                  addNrbesForm
                                    .get('countryId')
                                    .hasError('required')
                                "
                              >
                                Country is required
                              </mat-error>
                            </div>
                          </div>

                          <div
                            [ngStyle]="{
                              'margin-bottom':
                                addNrbesForm.get('categoryId')?.touched &&
                                addNrbesForm
                                  .get('categoryId')
                                  ?.hasError('required')
                                  ? '45px'
                                  : '75px',
                            }"
                          >
                            <label
                              for="operationsCategory"
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Category*
                              <span
                                matTooltip="Please share the appropriate category for your standard"
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span>
                            </label>
                            <div class="category-dropdown-wrapper">
                              <ng-multiselect-dropdown
                                [ngClass]="{
                                  'invalid-border':
                                    step0Group.get('categoryId')?.invalid &&
                                    step0Group.get('categoryId')?.touched,
                                }"
                                class="dropdown-list"
                                [placeholder]=""
                                [settings]="categorydropdownSettings"
                                [data]="categoryDropdownList"
                                [(ngModel)]="selectedCategory"
                                (onSelect)="onCategorySelect($event)"
                                [ngModelOptions]="{ standalone: true }"
                              >
                              </ng-multiselect-dropdown>
                            </div>
                          </div>
                          <div>
                            <mat-error
                              style="font-size: x-small; margin-bottom: 20px"
                              *ngIf="
                                addNrbesForm.get('categoryId').touched &&
                                addNrbesForm
                                  .get('categoryId')
                                  .hasError('required')
                              "
                            >
                              Category is required
                            </mat-error>
                          </div>

                          <div
                            [ngStyle]="{
                              'margin-bottom':
                                addNrbesForm.get('locationTypeId')?.touched &&
                                addNrbesForm
                                  .get('locationTypeId')
                                  ?.hasError('required')
                                  ? '45px'
                                  : '75px',
                            }"
                          >
                            <div
                              style="
                                display: flex;
                                justify-content: space-between;
                              "
                            >
                              <label
                                for="operationsCategory"
                                style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                "
                                >Location*
                                <span
                                  matTooltip="Please share where this standard may apply (physical space/location) at the Restaurant "
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "
                                ></span
                              ></label>
                              <button
                                *ngIf="selectedLocations.length > 1"
                                style="
                                  background: transparent;
                                  border: none;
                                  background-color: white;
                                  color: #de3428;
                                "
                                (click)="clearAllSelected()"
                              >
                                clear all
                              </button>
                            </div>

                            <div
                              style="max-height: 550px"
                              class="multiLocations"
                            >
                              <ng-multiselect-dropdown
                                [ngClass]="{
                                  'invalid-border':
                                    step0Group.get('locationTypeId')?.invalid &&
                                    step0Group.get('locationTypeId')?.touched,
                                }"
                                #locationDropdown
                                class="dropdown-list"
                                [placeholder]=""
                                [(ngModel)]="selectedLocations"
                                [settings]="dropdownSettings"
                                [data]="LocationsdropdownList"
                                (onSelect)="onItemSelect($event)"
                                (onDeSelect)="onItemSelect($event)"
                                (onSelectAll)="onSelectAll($event)"
                                [ngModelOptions]="{ standalone: true }"
                                (onDropDownOpen)="onDropdownOpen()"
                              >
                              </ng-multiselect-dropdown>
                            </div>
                          </div>
                          <div>
                            <mat-error
                              style="font-size: x-small; margin-bottom: 20px"
                              *ngIf="
                                addNrbesForm.get('locationTypeId').touched &&
                                addNrbesForm
                                  .get('locationTypeId')
                                  .hasError('required')
                              "
                            >
                              Location is required
                            </mat-error>
                          </div>

                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                            "
                            class="dates newForm"
                          >
                            <div style="width: 48%">
                              <label
                                style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                "
                                >New Restaurant Effective Date*
                                <span
                                  matTooltip="This is the date that the Market Standard takes effect for NEW STORE OPENINGS (NSO). Any newly built restaurants opened after this day in market will be subject to meeting the standard."
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "
                                ></span
                              ></label>
                              <mat-form-field>
                                <input
                                  matInput
                                  [matDatepicker]="picker2"
                                  formControlName="newRestaurantEffectiveFrom"
                                />
                                <mat-datepicker-toggle
                                  matSuffix
                                  [for]="picker2"
                                >
                                  <img
                                    matDatepickerToggleIcon
                                    src="../../assets/images/date-calender.svg"
                                    alt="Calendar"
                                    style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      margin-bottom: 2px;
                                    "
                                /></mat-datepicker-toggle>
                                <mat-datepicker
                                  #picker2
                                  style="height: 30px; width: 30px"
                                ></mat-datepicker>
                                <mat-error
                                  *ngIf="
                                    addNrbesForm.get(
                                      'newRestaurantEffectiveFrom'
                                    ).touched &&
                                    addNrbesForm
                                      .get('newRestaurantEffectiveFrom')
                                      .hasError('required')
                                  "
                                >
                                  Date is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div style="width: 48%">
                              <label
                                style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                "
                                >Existing Restaurant Effective Date*
                                <span
                                  matTooltip="This is the date that the Market Standard takes effect all for existing McDonald's restaurants. "
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "
                                ></span
                              ></label>
                              <mat-form-field>
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  formControlName="effectiveFrom"
                                />
                                <mat-datepicker-toggle matSuffix [for]="picker">
                                  <img
                                    matDatepickerToggleIcon
                                    src="../../assets/images/date-calender.svg"
                                    alt="Calendar"
                                    style="
                                      width: 20px;
                                      height: 20px;
                                      cursor: pointer;
                                      margin-bottom: 2px;
                                    "
                                /></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error
                                  *ngIf="
                                    addNrbesForm.get('effectiveFrom').touched &&
                                    addNrbesForm
                                      .get('effectiveFrom')
                                      .hasError('required')
                                  "
                                >
                                  Date is required
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div style="margin-top: 20px">
                            <!-- <button
                            matButton
                            matStepperPrevious
                            disabled
                            style="
                              padding: 4px 16px 4px 16px;
                              border-radius: 5px;
                              border-color: #c1c6cd;
                              background-color: #ffffff;
                              margin-right: 10px;
                            "
                          >
                            <img
                              src="/assets/images/leftarrow.svg"
                              alt="arrow"
                              style="margin-right: 5px"
                            />Back
                          </button> -->
                            <button
                              (click)="nextStep()"
                              matButton
                              matStepperNext
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;

                                background-color: #ffffff;
                              "
                            >
                              Next<img
                                src="/assets/images/rightarrow.svg"
                                alt="arrow"
                                style="margin-left: 5px"
                              />
                            </button>
                          </div>
                        </div>
                      </mat-step>

                      <mat-step [stepControl]="step1Group">
                        <ng-template matStepLabel>Description</ng-template>

                        <div class="col-9" style="margin: auto">
                          <div class="newForm">
                            <label
                              for="operationsCategory"
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Description for New Restaurants*
                              <span
                                matTooltip="Provide 1-2 sentences describing requirements for NEW build restaurants (NSO) per the Market Standard. If the same for new and existing, please copy and paste."
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span
                            ></label>
                            <div class="description">
                              <textarea
                                class="textarea"
                                placeholder="Enter new restaurant description"
                                [ngStyle]="{
                                  'margin-bottom':
                                    addNrbesForm.get('newrestaurantdescription')
                                      ?.touched &&
                                    addNrbesForm
                                      .get('newrestaurantdescription')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '10px',
                                }"
                                style="height: 120px"
                                matInput
                                name="description"
                                formControlName="newrestaurantdescription"
                                required
                                (paste)="
                                  onPasteCleanup('newrestaurantdescription')
                                "
                              ></textarea>

                              <mat-error
                                *ngIf="
                                  addNrbesForm.get('newrestaurantdescription')
                                    .touched &&
                                  addNrbesForm
                                    .get('newrestaurantdescription')
                                    .hasError('required')
                                "
                              >
                                Description is required
                              </mat-error>
                            </div>
                            <!-- <mat-form-field>
                           
                          </mat-form-field> -->
                          </div>

                          <mat-checkbox
                            (change)="copyDescriptionToExisting($event.checked)"
                            style="margin-bottom: 20px; color: #595a6c"
                          >
                            Use same description for existing restaurants too.
                          </mat-checkbox>

                          <div class="newForm">
                            <label
                              for="operationsCategory"
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Description for Existing Restaurants*
                              <span
                                matTooltip="Provide 1-2 sentences describing requirements for existing restaurants per the Market Minimum Standard. If the same for new and existing, please copy and paste."
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span
                            ></label>
                            <div class="description">
                              <textarea
                                class="textarea"
                                [disabled]="descriptionChecked"
                                placeholder="Enter existing restaurant description"
                                [ngStyle]="{
                                  'margin-bottom':
                                    addNrbesForm.get('standardDescription')
                                      ?.touched &&
                                    addNrbesForm
                                      .get('standardDescription')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '30px',
                                  'background-color': descriptionChecked
                                    ? '#F2F5F8'
                                    : 'transparent',
                                }"
                                style="height: 120px"
                                matInput
                                name="description"
                                formControlName="standardDescription"
                                required
                                (paste)="onPasteCleanup('description')"
                              ></textarea>

                              <mat-error
                                *ngIf="
                                  addNrbesForm.get('standardDescription')
                                    .touched &&
                                  addNrbesForm
                                    .get('standardDescription')
                                    .hasError('required')
                                "
                              >
                                Description is required
                              </mat-error>
                            </div>
                            <!-- <mat-form-field>
                           
                          </mat-form-field> -->
                          </div>

                          <div style="margin-top: 20px">
                            <button
                              (click)="previousStep()"
                              matButton
                              matStepperPrevious
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;
                                background-color: #ffffff;
                                margin-right: 10px;
                              "
                            >
                              <img
                                src="/assets/images/leftarrow.svg"
                                alt="arrow"
                                style="margin-right: 5px"
                              />Back
                            </button>
                            <button
                              matButton
                              (click)="nextStep()"
                              matStepperNext
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;

                                background-color: #ffffff;
                              "
                            >
                              Next<img
                                src="/assets/images/rightarrow.svg"
                                alt="arrow"
                                style="margin-left: 5px"
                              />
                            </button>
                          </div>
                        </div>
                      </mat-step>

                      <mat-step [stepControl]="step2Group">
                        <ng-template matStepLabel
                          >Details and Media</ng-template
                        >
                        <div class="col-9" style="margin: auto">
                          <label
                            for="operationsCategory"
                            style="
                              font-weight: 500;
                              color: #595a6c;
                              margin-bottom: 3px;
                            "
                            >Details*
                            <span
                              matTooltip="Provide a detailed overview on HOW to meet the standard. Include context - why required, benefits/risks, cost implications, procedures, prerequisites, next steps/actions and key contacts. "
                              style="
                                background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                background-repeat: no-repeat;
                                background-size: auto;
                                background-position: center;

                                padding: 10px;
                              "
                            ></span
                          ></label>
                          <quill-editor
                            [ngClass]="{
                              'invalid-note':
                                step2Group.get('note')?.invalid &&
                                step2Group.get('note')?.touched,
                            }"
                            name="note"
                            formControlName="note"
                            class="quill-editor-css"
                            (onEditorCreated)="onEditorCreated($event, 'note')"
                          >
                          </quill-editor>
                          <mat-error
                            *ngIf="
                              addNrbesForm.get('note').touched &&
                              addNrbesForm.get('note').hasError('required')
                            "
                            style="font-size: x-small"
                          >
                            Details required
                          </mat-error>

                          <div style="margin-top: 30px">
                            <label
                              for="operationsCategory"
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Additional Information
                              <span
                                matTooltip="Please add additional information if neccessary "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span
                            ></label>
                            <quill-editor
                              name="additionalInformation"
                              formControlName="additionalInformation"
                              class="quill-editor-css"
                              (onEditorCreated)="
                                onEditorCreated($event, 'additionalInformation')
                              "
                            >
                            </quill-editor>
                          </div>

                          <div style="margin-bottom: 20px; margin-top: 30px">
                            <div>
                              <label
                                for="operationsCategory"
                                style="
                                  font-weight: 500;
                                  color: #595a6c;
                                  margin-bottom: 3px;
                                "
                                >Resources and Supportive Information
                                <span
                                  matTooltip="Please provide a URL link to any resources/guides/supporting documents housed on SharePoint or OneDrive. Please ensure that permissions are configured appropriately, ensuring users have access. "
                                  style="
                                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                    background-repeat: no-repeat;
                                    background-size: auto;
                                    background-position: center;

                                    padding: 10px;
                                  "
                                ></span
                              ></label>
                            </div>
                            <div formArrayName="resourceLinks1">
                              <div
                                *ngFor="
                                  let link of resourceLinks1.controls;
                                  let i = index
                                "
                                [formGroupName]="i"
                                class="resourceBlock"
                                [ngStyle]="{
                                  'margin-bottom':
                                    addNrbesForm.get('linksFieldValid')
                                      ?.touched ||
                                    addNrbesForm.get('linksFieldValid')?.invalid
                                      ? '20px'
                                      : '20px',
                                }"
                              >
                                <div
                                  style="position: relative; flex: 1"
                                  class="resourceLinkInValid"
                                  [ngClass]="{
                                    invalidborder:
                                      link.get('url')?.value == '' &&
                                      link.get('title')?.value,
                                  }"
                                >
                                  <input
                                    type="text"
                                    formControlName="url"
                                    (input)="onEnterResourceTitle(link)"
                                    (paste)="onPasteLink($event, link)"
                                    (keydown)="disableTyping($event)"
                                    placeholder="Paste Link here..."
                                    class="resource-input"
                                  />

                                  <img
                                    *ngIf="link.get('url')?.value === ''"
                                    alt="mail"
                                    (click)="pasteLink(link)"
                                    src="/assets/images/Group (1).svg"
                                    style="
                                      position: absolute;
                                      right: 10px;
                                      top: 50%;
                                      transform: translateY(-50%);
                                      width: 18px;
                                      height: 18px;
                                      cursor: pointer;
                                    "
                                  />
                                  <svg
                                    (click)="openLink(link.get('url')?.value)"
                                    *ngIf="link.get('url')?.value !== ''"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-box-arrow-up-right link-svg"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                    />
                                  </svg>
                                  <div style="position: absolute">
                                    <mat-error
                                      *ngIf="
                                        link.get('title')?.value &&
                                        link.get('url')?.value === ''
                                      "
                                      style="font-size: x-small"
                                    >
                                      Url is required, if Title is provided.
                                    </mat-error>
                                  </div>
                                </div>

                                <div
                                  style="position: relative; flex: 2"
                                  class="resourceTitleInValid"
                                  [ngClass]="{
                                    invalidborder:
                                      link.get('title')?.value == '' &&
                                      link.get('url')?.value,
                                  }"
                                >
                                  <input
                                    type="text"
                                    (input)="onEnterResourceTitle(link)"
                                    formControlName="title"
                                    placeholder="Enter Title"
                                    class="resource-input resource-description"
                                  />
                                  <img
                                    (click)="removeLink(i)"
                                    alt="link"
                                    src="/assets/images/Right Link.svg"
                                    style="
                                      position: absolute;
                                      right: 10px;
                                      top: 50%;
                                      transform: translateY(-50%);
                                      width: 30px;
                                      height: 30px;
                                      cursor: pointer;
                                    "
                                  />
                                  <div style="position: absolute">
                                    <mat-error
                                      *ngIf="
                                        link.get('url')?.value &&
                                        link.get('title')?.value === ''
                                      "
                                      style="font-size: x-small"
                                    >
                                      Title is required, if URL is provided.
                                    </mat-error>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              style="
                                border: 1px solid #ced2ed;
                                padding: 6px 10px 6px 10px;
                                background-color: #f1f3fb;
                                color: #5a69bf;
                                border-radius: 6px;
                                font-weight: 500;
                                margin-bottom: 10px;
                              "
                              type="button"
                              class="add-link-btn"
                              (click)="addLinks()"
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                              >
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                              </svg>
                              Add Another Link
                            </button>
                          </div>
                          <div style="margin-top: 20px">
                            <button
                              (click)="previousStep()"
                              matButton
                              matStepperPrevious
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;
                                background-color: #ffffff;
                                margin-right: 10px;
                              "
                            >
                              <img
                                src="/assets/images/leftarrow.svg"
                                alt="arrow"
                                style="margin-right: 5px"
                              />Back
                            </button>
                            <button
                              matButton
                              (click)="nextStep()"
                              matStepperNext
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;

                                background-color: #ffffff;
                              "
                            >
                              Next<img
                                src="/assets/images/rightarrow.svg"
                                alt="arrow"
                                style="margin-left: 5px"
                              />
                            </button>
                          </div>
                        </div>
                      </mat-step>

                      <mat-step [stepControl]="step3Group">
                        <ng-template matStepLabel>Key Contacts</ng-template>

                        <div class="col-9" style="margin: auto">
                          <div>
                            <label
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Key Contacts
                              <span
                                matTooltip="Please share an email address for users who may have questions "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span
                            ></label>
                            <div style="display: flex; position: relative">
                              <div class="mail newForm" style="width: 100%">
                                <div style="display: flex; position: relative">
                                  <div class="mail newForm" style="width: 100%">
                                    <div class="title">
                                      <input
                                        [ngStyle]="{
                                          'margin-bottom':
                                            addNrbesForm.get('keyContact')
                                              ?.touched &&
                                            addNrbesForm
                                              .get('keyContact')
                                              ?.hasError('email')
                                              ? '0px'
                                              : '20px',
                                        }"
                                        name="keyContact"
                                        formControlName="keyContact"
                                        placeholder="user@domain.com "
                                        (paste)="onPasteCleanup('keyContact')"
                                        class="key-contact"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    style="
                                      position: absolute;
                                      right: 10px;

                                      padding: 11px 11px 8px 14px;
                                      border-left: 1.5px solid #c1c6cd;
                                    "
                                  >
                                    <img
                                      alt="mail"
                                      src="/assets/images/mail.svg"
                                    />
                                  </div>
                                </div>

                                <mat-error
                                  style="
                                    font-size: x-small;
                                    margin-bottom: 20px;
                                  "
                                  *ngIf="
                                    addNrbesForm.get('keyContact')?.touched &&
                                    addNrbesForm
                                      .get('keyContact')
                                      ?.hasError('email')
                                  "
                                >
                                  Please enter a valid email address
                                </mat-error>
                              </div>

                              <div
                                style="
                                  position: absolute;
                                  right: 10px;

                                  padding: 11px 11px 10px 14px;
                                  border-left: 1.5px solid #c1c6cd;
                                "
                              >
                                <span>
                                  <img
                                    alt="mail"
                                    src="/assets/images/mail.svg"
                                  />
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="newForm">
                            <label
                              style="
                                font-weight: 500;
                                color: #595a6c;
                                margin-bottom: 3px;
                              "
                              >Global Approved Hardware/Equipment
                              <span
                                matTooltip="Provide links to any Globally Approved Hardware or Equipment that enable restaurants to meet the Global Minimum Standard "
                                style="
                                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                                  background-repeat: no-repeat;
                                  background-size: auto;
                                  background-position: center;

                                  padding: 10px;
                                "
                              ></span
                            ></label>
                            <div class="description">
                              <textarea
                                class="textarea"
                                placeholder="Enter Description"
                                [ngStyle]="{
                                  'margin-bottom':
                                    addNrbesForm.get('keyContactDesc')
                                      ?.touched &&
                                    addNrbesForm
                                      .get('keyContactDesc')
                                      ?.hasError('required')
                                      ? '0px'
                                      : '30px',
                                }"
                                matInput
                                style="height: 120px"
                                name="description"
                                formControlName="keyContactDesc"
                                (paste)="onPasteCleanup('keyContactDesc')"
                              ></textarea>
                              <mat-error
                                *ngIf="
                                  addNrbesForm.get('keyContactDesc').touched &&
                                  addNrbesForm
                                    .get('keyContactDesc')
                                    .hasError('required')
                                "
                              >
                                Description is required
                              </mat-error>
                            </div>
                            <!-- <mat-form-field>
                          
                        </mat-form-field> -->
                          </div>

                          <div style="margin-top: 20px">
                            <button
                              (click)="previousStep()"
                              matButton
                              matStepperPrevious
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;
                                background-color: #ffffff;
                                margin-right: 10px;
                              "
                            >
                              <img
                                src="/assets/images/leftarrow.svg"
                                alt="arrow"
                                style="margin-right: 5px"
                              />Back
                            </button>
                            <button
                              disabled
                              matButton
                              matStepperNext
                              style="
                                width: 100px;
                                height: 39px;

                                font-weight: 500;
                                border-radius: 5px;
                                color: #d2d3d5;
                                border: 1px solid #e0e2e6;

                                background-color: #ffffff;
                              "
                            >
                              Next<img
                                src="/assets/images/arrow-right 1.svg"
                                alt="arrow"
                                style="margin-left: 5px"
                              />
                            </button>

                            <button
                              (click)="nextStep()"
                              matButton
                              matStepperNext
                              [ngStyle]="{
                                color: step3Group.invalid ? '#888888' : 'black',
                                cursor: step3Group.invalid
                                  ? 'not-allowed'
                                  : 'pointer',
                                backgroundColor: step3Group.invalid
                                  ? '#e0e0e0'
                                  : '#ffbc0f',
                                borderColor: '#c1c6cd',
                                fontWeight: 'bold',
                                float: 'right',
                                padding: '4px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                width: '100px',
                                height: '39px',
                              }"
                            >
                              Review
                            </button>
                          </div>
                        </div>
                      </mat-step>

                      <mat-step>
                        <ng-template matStepLabel>Preview</ng-template>
                        <div style="padding: 12px">
                          <div class="review-page-container">
                            <!-- <div class="header"> -->
                            <!-- <div class="stamp">{{ data.stampText }}</div> -->
                            <!-- </div> -->

                            <div class="info-main">
                              <div>
                                <h1
                                  class="lastpage-title"
                                  style="padding: 10px"
                                >
                                  {{ addNrbesForm.get("title")?.value }}
                                </h1>
                              </div>
                              <div class="info-section">
                                <div class="info-column left-column">
                                  <div class="info-row">
                                    <span class="reviewPage-icon date"></span>
                                    <span class="label left-label"
                                      >New Restaurant Effective Date</span
                                    >
                                    <span class="value">{{
                                      addNrbesForm.get(
                                        "newRestaurantEffectiveFrom"
                                      )?.value | date: "dd, MMM yyyy"
                                    }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span class="reviewPage-icon date2"></span>
                                    <span class="label left-label"
                                      >Existing Restaurant Effective Date</span
                                    >
                                    <span class="value">{{
                                      addNrbesForm.get("effectiveFrom")?.value
                                        | date: "dd, MMM yyyy"
                                    }}</span>
                                  </div>

                                  <!-- <div class="info-row">
                                  <span
                                    class="reviewPage-icon standardType"
                                  ></span>
                                  <span class="label">Standard Type</span>
                                  <span class="value">dssd</span>
                                </div> -->
                                  <div class="info-row">
                                    <span
                                      class="reviewPage-icon category"
                                    ></span>
                                    <span class="label left-label"
                                      >Category</span
                                    >
                                    <span class="value">{{
                                      categoryForLastPage
                                    }}</span>
                                  </div>
                                  <!-- 
                              <div class="info-row">
                                <span class="icon clock-icon"></span>
                                <span class="label">Last Modified</span>
                                <span class="value">{{
                                  data.lastModified
                                }}</span>
                              </div> -->
                                </div>

                                <div class="divider"></div>

                                <div class="info-column right-column">
                                  <div class="info-row">
                                    <span
                                      class="reviewPage-icon location"
                                    ></span>
                                    <span class="label right-label"
                                      >Location</span
                                    >
                                    <span class="value">{{
                                      selectedLocationNames
                                    }}</span>
                                  </div>

                                  <!-- <div class="info-row" *ngIf="subLocationselected !=''">
                                  <span
                                    class="reviewPage-icon Sublocation"
                                  ></span>
                                  <span class="label">Sub Location</span>
                                  <span class="value">{{
                                    lastPageSublocation
                                  }}</span>
                                </div> -->

                                  <div class="info-row">
                                    <span
                                      class="reviewPage-icon keyContact"
                                    ></span>
                                    <span class="label right-label"
                                      >Key Contact</span
                                    >
                                    <span class="value">{{
                                      addNrbesForm.get("keyContact")?.value !=
                                      ""
                                        ? addNrbesForm.get("keyContact")?.value
                                        : "--"
                                    }}</span>
                                  </div>

                                  <div class="info-row">
                                    <span
                                      class="reviewPage-icon createdOn"
                                    ></span>
                                    <span class="label right-label"
                                      >Created On</span
                                    >
                                    <span class="value">{{
                                      createdOn | date: "dd, MMM yyyy"
                                    }}</span>
                                  </div>

                                  <!-- <div class="info-row">
                                <span class="icon user-icon"></span>
                                <span class="label">Key Contact</span>
                                <span class="value">{{ data.keyContact }}</span>
                              </div> -->
                                </div>
                              </div>
                            </div>

                            <div class="description-section">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  align-content: center;
                                "
                              >
                                <h2 class="section-title">
                                  Description for New Restaurant
                                </h2>
                                <button class="copyIcon">
                                  <img
                                    (click)="
                                      copyText(
                                        addNrbesForm.get(
                                          'newrestaurantdescription'
                                        ).value
                                      );
                                      $event.stopPropagation()
                                    "
                                    src="../../assets/images/copy text.svg"
                                    alt=""
                                  />
                                </button>
                              </div>
                              <p class="description-text">
                                {{
                                  addNrbesForm.get("newrestaurantdescription")
                                    ?.value
                                }}
                              </p>
                            </div>

                            <div class="description-section">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  align-content: center;
                                "
                              >
                                <h2 class="section-title">
                                  Description for Existing Restaurant
                                </h2>
                                <button class="copyIcon">
                                  <img
                                    (click)="
                                      copyText(
                                        addNrbesForm.get('standardDescription')
                                          .value
                                      );
                                      $event.stopPropagation()
                                    "
                                    src="../../assets/images/copy text.svg"
                                    alt=""
                                  />
                                </button>
                              </div>
                              <p class="description-text">
                                {{
                                  addNrbesForm.get("standardDescription")?.value
                                }}
                              </p>
                            </div>

                            <div
                              class="details-section"
                              style="margin-top: 20px"
                            >
                              <div
                                class="details-header"
                                (click)="toggleDetails()"
                              >
                                <div class="details-title-wrapper">
                                  <div>
                                    <span class="toggle-icon">
                                      <img
                                        *ngIf="!detailsExpanded"
                                        src="../../assets/images/s-add 1.svg"
                                        alt="Expand"
                                        style="margin-bottom: 3px" />
                                      <img
                                        *ngIf="detailsExpanded"
                                        src="../../assets/images/cross (2).svg"
                                        alt="Collapse"
                                        style="margin-bottom: 3px"
                                    /></span>
                                    <!-- <span class="details-icon">☑</span> -->
                                    <span class="details-title"> Details </span>
                                  </div>
                                  <div *ngIf="detailsExpanded">
                                    <img
                                      (click)="
                                        copyText(addNrbesForm.get('note').value)
                                      "
                                      src="../../assets/images/copy text.svg"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                class="details-content"
                                [class.expanded]="detailsExpanded"
                              >
                                <div
                                  [innerHTML]="getDetails()"
                                  class="detail-section"
                                ></div>
                              </div>
                            </div>

                            <div
                              class="details-section"
                              style="margin-top: 20px"
                              *ngIf="
                                addNrbesForm.get('additionalInformation').value
                              "
                            >
                              <div
                                class="details-header"
                                (click)="toggleDetails2()"
                              >
                                <div class="details-title-wrapper">
                                  <div>
                                    <span class="toggle-icon">
                                      <img
                                        [ngStyle]="{
                                          display: additionalInfoExpanded
                                            ? 'none'
                                            : '',
                                        }"
                                        *ngIf="!additionalInfoExpanded"
                                        src="../../assets/images/s-add 1.svg"
                                        alt="Expand"
                                        style="margin-bottom: 3px" />
                                      <img
                                        [ngStyle]="{
                                          display: !additionalInfoExpanded
                                            ? 'none'
                                            : '',
                                        }"
                                        *ngIf="additionalInfoExpanded"
                                        src="../../assets/images/cross (2).svg"
                                        alt="Collapse"
                                        style="margin-bottom: 3px"
                                    /></span>
                                    <!-- <span class="details-icon">☑</span> -->
                                    <span class="details-title">
                                      Additional Info
                                    </span>
                                  </div>
                                  <div *ngIf="additionalInfoExpanded">
                                    <img
                                      (click)="
                                        copyText(
                                          addNrbesForm.get(
                                            'additionalInformation'
                                          ).value
                                        )
                                      "
                                      src="../../assets/images/copy text.svg"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>

                              <div
                                class="details-content"
                                [class.expanded]="additionalInfoExpanded"
                              >
                                <div
                                  [innerHTML]="getAdditionalInfo()"
                                  class="detail-section"
                                ></div>
                              </div>
                            </div>

                            <div
                              class="bottom-sections"
                              [class.single-column]="
                                (hasResourceUrls &&
                                  !addNrbesForm.get('keyContactDesc')?.value) ||
                                (!hasResourceUrls &&
                                  addNrbesForm.get('keyContactDesc')?.value)
                              "
                            >
                              <div
                                class="resources-section"
                                *ngIf="hasResourceUrls"
                              >
                                <div class="section-header">
                                  <h2 class="section-heading">
                                    Resources and Supporting Information
                                  </h2>
                                  <span class="info-icon-circle">?</span>
                                </div>
                                <div
                                  class="links-list"
                                  formArrayName="resourceLinks1"
                                >
                                  <a
                                    *ngFor="
                                      let resource of resourceLinks1.controls;
                                      let i = index
                                    "
                                    [formGroupName]="i"
                                    [href]="resource.get('url')?.value"
                                    class="resource-link"
                                  >
                                    {{ resource.get("title")?.value }}
                                  </a>
                                </div>
                              </div>

                              <div
                                class="hardware-section"
                                *ngIf="
                                  addNrbesForm.get('keyContactDesc')?.value
                                "
                              >
                                <div class="section-header">
                                  <h2 class="section-heading">
                                    Global Approved Hardware/Equipment
                                  </h2>
                                  <span class="info-icon-circle">?</span>
                                </div>
                                <div class="hardware-content">
                                  <a
                                    [href]="
                                      addNrbesForm.get('keyContactDesc')?.value
                                    "
                                    class="hardware-link"
                                    target="_blank"
                                  >
                                    {{
                                      addNrbesForm.get("keyContactDesc")?.value
                                    }}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-top: 40px">
                            <button
                              matButton
                              (click)="previousStep()"
                              matStepperPrevious
                              style="
                                width: 100px;
                                height: 39px;
                                color: #4d5258;
                                font-weight: 500;
                                border-radius: 5px;
                                border: 1px solid #c1c6cd;
                                background-color: #ffffff;
                                margin-right: 10px;
                              "
                            >
                              <img
                                src="/assets/images/leftarrow.svg"
                                alt="arrow"
                                style="margin-right: 5px"
                              />Back
                            </button>
                            <button
                              disabled
                              matButton
                              matStepperNext
                              style="
                                width: 100px;
                                height: 39px;

                                font-weight: 500;
                                border-radius: 5px;
                                color: #d2d3d5;
                                border: 1px solid #e0e2e6;

                                background-color: #ffffff;
                              "
                            >
                              Next<img
                                src="/assets/images/arrow-right 1.svg"
                                alt="arrow"
                                style="margin-left: 5px"
                              />
                            </button>

                            <button
                              [disabled]="checkFormValidity()"
                              (click)="submit()"
                              matButton
                              [ngStyle]="{
                                color: step3Group.invalid ? '#888888' : 'black',
                                cursor: step3Group.invalid
                                  ? 'not-allowed'
                                  : 'pointer',
                                backgroundColor: step3Group.invalid
                                  ? '#e0e0e0'
                                  : '#ffbc0f',
                                borderColor: '#c1c6cd',
                                fontWeight: 'bold',
                                float: 'right',
                                padding: '4px 16px',
                                borderRadius: '5px',
                                border: 'none',
                                width: '100px',
                                height: '39px',
                              }"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </mat-step>
                    </form>
                  </mat-stepper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
    <!-- <mat-card-footer class="mcd-card-footer">
      <button
        class="mcd-btn mcd-btn-primary"
        mat-raised-button
        (click)="reset()"
      >
        Reset
      </button>
      <button
        class="mcd-btn mcd-btn-secondary"
        mat-raised-button
        (click)="submit()"
        [disabled]="addNrbesForm.invalid"
      >
        Add
      </button>
    </mat-card-footer> -->
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
